import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { BackendService } from 'auth/src/public-api';
import { AuthService } from '../../shared/services/auth.service';
import { UserSummaryData } from '../modals/ai-general-summary-modal/models/userSummaryData';

@Injectable()
export class AiSummaryService {

    constructor(
        private _httpService: BackendService,
        private authService: AuthService,
        private http: HttpClient
    ) {
    }

    public getReviewsAiUserSummary(cycleParticipantId: number) {
        return this._httpService.get<UserSummaryData>('getReviewsAiUserSummary', [], [
            { 'name': 'cycleParticipantId', 'value': cycleParticipantId as any },

        ]);
    }

    getReviewSummaryOnly(cycleParticipantId: number){
        return this._httpService.get<any>('GetAiReviewSummary',[], [
            { name: 'cycleParticipantId', value: cycleParticipantId as any},
        ]);
    }

    generateReviewSummaryOnly(body: {cycleParticipantId: number; language?: string; forceRegenerate?: boolean}){
        return this._httpService.post(`GenerateAiReviewSummary`, body);
    }

    
}
